var NF_SaveProgress = Marionette.Application.extend({

    initialize: function( options ){

        // Load Controllers.
        new nfSaveProgressActiveController();
        new nfSaveProgressSaveButtonController();
        new nfSaveProgressPassiveController();

        Backbone.Radio.channel( 'forms' ).reply( 'save:fieldAttributes', this.getfieldAttributes, this );
        Backbone.Radio.channel( 'forms' ).reply( 'save:updateFieldsCollection', this.updateFieldsCollection, this );
    },

    getfieldAttributes: function( formID ) {
        var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formID );

        var fields = formModel.get( 'fields' ).filter( function( fieldModel, key ){
            if ( 'html' == fieldModel.get( 'type' ) ) return false;
            // If we don't have a value...
            // AND our field is anything other than a table editor...
            if ( ! fieldModel.get( 'value' ) && 'table_editor' != fieldModel.get( 'type' ) ) return false;
            // If the model is clean...
            // AND it has a type of anything other than file upload, table editor, or repeater...
            // AND it's not a date field with time values set (changeHoursMinutes doesn't set clean:false)
            // AND it's not a field inside a Repeatable Fieldset (parentType attribute)
            // Repeater fields are always saved when they have a value because their child
            // values are aggregated into the parent model via setAllRepeatersValues, which
            // does not set clean:false on the parent.
            if ( fieldModel.get( 'clean' ) && 'file_upload' != fieldModel.get( 'type' ) && 'table_editor' != fieldModel.get( 'type' ) && 'repeater' != fieldModel.get( 'type' ) && ! fieldModel.get( 'parentType' ) ) {
                // Exception: Date fields with selected_hour are modified even if marked clean
                // This works around core NF not setting clean:false in changeHoursMinutes
                if ( 'date' == fieldModel.get( 'type' ) && fieldModel.get( 'selected_hour' ) ) {
                    return true; // Keep this field
                }
                return false;
            }
            return true;
        });

        var omit = [
            /* core */ 'admin_label', 'element_class', 'required', 'container_class', 'custom_mask','mask', 'manual_key', 'drawerDisabled', 'input_limit', 'input_limit_msg', 'input_limit_type', 'help_text', 'desc_text', 'created_at', 'editActive', 'disabled', 'afterField', 'beforeField', 'classes', 'confirm_field', 'element_templates', 'errors', 'formID', 'key', 'label', 'label_pos', 'mirror_field', 'objectDomain', 'objectType', 'old_classname', 'order', 'parentType', 'placeholder', 'reRender', 'type', 'wrap_template',
            /* List Fields */ 'options',
            /* Table Editor */ 'hot', 'tableConfig',
            /* File Uploads */ 'uploadNonce', 'upload_types',
            /* Layout & Styles */ 'cellcid',
            /* Date/Time Fields - these are PHP-generated HTML that should not be saved/restored */
            'hours_options', 'minutes_options',
            /* Repeater internals */ 'sets', 'fields', 'isUpdated', 'repeaterField'
        ];

        // Attributes to be saved.
        var atts = fields.map( function( fieldModel, key ) {
            return _.omit( fieldModel.attributes, function( value, key, object ){

                // Omit function properties.
                if( 'function' == typeof value ) return true;

                // Omit known "non-essential" core attributes.
                if( -1 !== omit.indexOf( key ) ) return true;

                // Omit Layout & Styles attributes.
                if( -1 !== key.indexOf( '_styles_' ) ) return true;
               return false;
            });
        });
        return atts;
    },

    updateFieldsCollection: function( formInstanceID, savedFields ){
        // Nothing to restore — return early without resetting the fields collection.
        // Calling fieldsCollection.reset() with no saved data to apply would create a
        // second fieldRepeaterSetCollection alongside the one from the initial page render.
        // Both would listen to add:fieldset on the radio channel, causing stale models to
        // accumulate in nfAllRepeaterFieldsModels and phantom rows to appear after deletion.
        if ( ! savedFields || ! savedFields.length ) {
            return;
        }

        var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formInstanceID );
        var fieldsCollection = formModel.get( 'fields' );

        var instanceID = formInstanceID.toString().split('_')[1];

        // Preserve hours_options/minutes_options from date fields before reset.
        // These are PHP-generated HTML strings that would be lost during collection reset.
        var dateFieldOptions = {};
        fieldsCollection.each(function(field) {
            if (field.get('type') === 'date') {
                var fieldId = field.get('id');
                dateFieldOptions[fieldId] = {
                    hours_options: field.get('hours_options'),
                    minutes_options: field.get('minutes_options')
                };
            }
        });

        var defaults = formModel.get( 'loadedFields' );
        var replacedFields = fieldsCollection.models.slice();
        fieldsCollection.reset( defaults );
        this.forwardReplacedFieldValues( replacedFields, fieldsCollection );

        // Restore hours_options/minutes_options to date fields after reset
        _.each(dateFieldOptions, function(options, fieldId) {
            var field = fieldsCollection.get(fieldId);
            if (field && options.hours_options) {
                field.set('hours_options', options.hours_options, { silent: true });
                field.set('minutes_options', options.minutes_options, { silent: true });
            }
        });

        _.each( savedFields, function( savedField ){
            var fieldID = parseInt( savedField.id );

            if('undefined' !== typeof instanceID){
                fieldID += '_' + instanceID;
            }

            var field   = fieldsCollection.get( fieldID );
            var atts    = _.omit( savedField, [
                /* Core */ 'id', 'required',
                /* File Uploads */ 'uploadNonce', 'upload_types',
                /* Date/Time - preserve PHP-generated HTML, don't restore saved versions */
                'hours_options', 'minutes_options'
            ] );

            // Force `visible` attribute to a String
            if( 'undefined' != typeof atts.visible ) {
                atts.visible = atts.visible.toString();
            }

            if( 'undefined' != typeof field ) {
                // #106 fix: Wrap in try-catch to prevent errors from one field
                // (e.g., Confirm fields) from stopping restoration of subsequent fields
                try {
                var fieldType = field.get('type');
                var dateMode = field.get('date_mode');
                var isDateField = fieldType === 'date';
                var isRepeaterField = fieldType === 'repeater';
                var hasTimeComponent = dateMode && dateMode !== 'date_only';

                if (isRepeaterField && atts.value && 'object' === typeof atts.value) {
                    // Repeater field: restore via the Backbone API rather than field.set(atts),
                    // which caused a Marionette _initialEvents crash.
                    // Find the highest row index to determine how many rows to add
                    var maxRowIndex = 0;
                    _.each( atts.value, function( childData, childID ) {
                        var parts = String( childID ).split('_');
                        var rowIndex = parseInt( parts[ parts.length - 1 ] );
                        if ( !isNaN( rowIndex ) && rowIndex > maxRowIndex ) {
                            maxRowIndex = rowIndex;
                        }
                    });
                    // reset() already created one default row (index 0); add any extras.
                    // Call addSet() directly on this collection rather than broadcasting
                    // via the radio channel. Old fieldRepeaterSetCollection instances from
                    // the initial page load are never destroyed and keep listening on the
                    // channel — broadcasting would cause them to add rows too, polluting
                    // nfAllRepeaterFieldsModels with stale models that break deletion saves.
                    var setsCollection = field.get('sets');
                    for ( var i = 1; i <= maxRowIndex; i++ ) {
                        setsCollection.addSet( field.get('id') );
                    }
                    // Build a lookup map of childID → saved value
                    var savedValueMap = {};
                    _.each( atts.value, function( childData, childID ) {
                        savedValueMap[ childID ] = childData.value;
                    });
                    // Set values on the current live inner models (from the current sets
                    // collection). get:repeaterFieldById is not used because
                    // nfAllRepeaterFieldsModels accumulates stale models across resets and
                    // returns the wrong instance. Use { silent: true } to prevent
                    // onChangeModelValue in the passive controller from overwriting
                    // localStorage with empty/partial data mid-restoration.
                    setsCollection.each( function( setModel ) {
                        var innerFields = setModel.get('fields');
                        if ( ! innerFields ) return;
                        innerFields.each( function( innerFieldModel ) {
                            var childID = innerFieldModel.get('id');
                            if ( savedValueMap.hasOwnProperty( childID ) ) {
                                innerFieldModel.set( 'value', savedValueMap[ childID ], { silent: true } );
                                innerFieldModel.set( 'clean', false, { silent: true } );
                            }
                        });
                    });
                    // Re-render all fieldsets now that the inner models have their values
                    Backbone.Radio.channel('field-repeater').trigger('rerender:fieldsets');
                    // Update the parent repeater's aggregated value directly
                    field.set( 'value', atts.value, { silent: true } );
                } else if (isDateField) {
                    // Multi-Part Forms renders all steps in the DOM upfront but only initializes
                    // flatpickr on the visible step. For hidden steps, _flatpickr is null.
                    // Calling field.set(atts) unconditionally fires change:value, which triggers
                    // isDateValid(). Without flatpickr, isDateValid returns undefined (falsy),
                    // so dateChange() adds an "invalid date" error that blocks form submission.
                    var baseID = parseInt(savedField.id);
                    var inputEl = document.querySelector("[name='nf-field-" + baseID + "']");
                    var flatpickrReady = inputEl && inputEl._flatpickr;

                    if (flatpickrReady) {
                        // Visible step: set normally — flatpickr is initialized so isDateValid runs correctly.
                        field.set(atts);
                        // Date-only: reRender refreshes the display. Date+time: skip reRender to
                        // preserve the PHP-generated hours/minutes HTML (DOM selects updated below).
                        if (!hasTimeComponent) {
                            field.trigger('reRender');
                        }
                    } else {
                        // Hidden step: silently update the model to avoid triggering the date change
                        // handler. Defer change:value until the field renders on its step.
                        // Note: render:view on the 'date' channel (which runs initDatepicker) fires
                        // before render:view on the 'fields' channel, so flatpickr is guaranteed
                        // to be initialized when our deferred handler runs.
                        field.set(atts, { silent: true });
                        (function(capturedField) {
                            var fieldID = capturedField.get('id');
                            var formID  = capturedField.get('formID');

                            // Guard: if changeDate.js fires isDateValid() while the field's
                            // element is not yet in the document (e.g. conditional logic
                            // evaluating a saved trigger-field value before step 2 renders),
                            // remove the stale error it adds. Our listener registers after
                            // changeDate.js, so it fires second and wins.
                            var removeStaleError = function(model) {
                                if (model.get('id') === fieldID && model.get('formID') === formID) {
                                    var el = document.querySelector("[name='nf-field-" + fieldID + "']");
                                    if (!el || !el._flatpickr) {
                                        nfRadio.channel('fields').request('remove:error', fieldID, 'invalid-date');
                                    }
                                }
                            };
                            nfRadio.channel('date').on('change:modelValue', removeStaleError);

                            // Once the field is attached to the DOM (flatpickr initialized),
                            // retire the guard and let isDateValid() run properly.
                            var onFieldAttach = function(fieldView) {
                                if (fieldView.model &&
                                    fieldView.model.get('id') === fieldID &&
                                    fieldView.model.get('formID') === formID) {
                                    nfRadio.channel('date').off('change:modelValue', removeStaleError);
                                    capturedField.trigger('change:value', capturedField, capturedField.get('value'));
                                    nfRadio.channel('date').off('attach:view', onFieldAttach);
                                }
                            };
                            nfRadio.channel('date').on('attach:view', onFieldAttach);
                        })(field);
                        // Do not reRender — the field is not yet in the visible DOM, and reRender
                        // would output the locale-formatted date value on <input type="date">,
                        // producing a browser format warning before flatpickr can correct it.
                    }
                } else {
                    field.set(atts);
                    field.trigger('reRender');
                }

                // Update time select values directly in the DOM for date fields with time components.
                // For hidden steps the container won't be found, so this safely no-ops.
                var hasValue = atts.value || atts.selected_hour;
                if (isDateField && hasTimeComponent && hasValue) {
                    var baseFieldID = parseInt(savedField.id);
                    var container = jQuery('#nf-field-' + baseFieldID + '-container');

                    if (container.length) {
                        var hour = atts.selected_hour;
                        var minute = atts.selected_minute;
                        var ampm = atts.selected_ampm;

                        // Parse from value if selected_hour not available
                        if (!hour && atts.value) {
                            var timeParts = atts.value.match(/(\d{1,2}):(\d{2})(?:\s*(am|pm))?/i);
                            if (timeParts) {
                                hour = timeParts[1];
                                minute = timeParts[2];
                                ampm = timeParts[3];
                            }
                        }

                        if (hour && minute) {
                            var hourSelect = container.find('select.hour');
                            var minuteSelect = container.find('select.minute');

                            if (hourSelect.length && minuteSelect.length) {
                                hourSelect.val(String(hour));
                                minuteSelect.val(String(minute));
                                hourSelect.trigger('change');
                                minuteSelect.trigger('change');

                                if (ampm) {
                                    var ampmSelect = container.find('select.ampm');
                                    if (ampmSelect.length) {
                                        ampmSelect.val(ampm.toLowerCase());
                                        ampmSelect.trigger('change');
                                    }
                                }
                            }
                        }
                    }
                }
                } catch( e ) {
                    // #106 fix: Log error but continue processing remaining fields
                    if( console && console.warn ) {
                        console.warn( 'Save Progress: Failed to restore field ' + fieldID, e );
                    }
                }
            }
        });

        Backbone.Radio.channel( 'fields' ).trigger( 'reset:collection', fieldsCollection );

        // The loops below run listeners from core and other add-ons. Like the restore loop
        // above (#106), each field is guarded on its own: an error here must not escape to
        // the caller, which still has to suppress the native submission (#289). See #303.

        // #119 fix: Trigger re-render of HTML fields to update merge tags with restored values
        fieldsCollection.each( function( fieldModel ) {
            if( 'html' === fieldModel.get( 'type' ) ) {
                try {
                    fieldModel.trigger( 'reRender' );
                } catch( e ) {
                    if( console && console.warn ) {
                        console.warn( 'Save Progress: Failed to re-render field ' + fieldModel.get( 'id' ), e );
                    }
                }
            }
        });

        // #242 fix: Trigger change events for fields with values to ensure merge tags and calculations update
        _.each( savedFields, function( savedField ){
            var fieldID = parseInt( savedField.id );

            if('undefined' !== typeof instanceID){
                fieldID += '_' + instanceID;
            }

            var field = fieldsCollection.get( fieldID );

            if( 'undefined' != typeof field && 'undefined' != typeof savedField.value && '' !== savedField.value ) {
                // Trigger change event to recalculate merge tags and field calculations
                try {
                    Backbone.Radio.channel( 'field-' + fieldID ).trigger( 'change:modelValue', field );
                } catch( e ) {
                    if( console && console.warn ) {
                        console.warn( 'Save Progress: Failed to update field ' + fieldID, e );
                    }
                }
            }
        });
    },

    /**
     * #119: point the field models a restore replaced at the models that replaced them.
     *
     * Resetting the fields collection builds new field models, but core's HTML field
     * controller keeps the models it found when the page loaded and resolves
     * {field:key} merge tags from their values. Those models never see the restored
     * values, so HTML fields render the merge tags blank. Each replaced model now
     * reads its value from the current model with the same ID.
     *
     * @param {Array}               replacedFields   Models in the collection before the reset.
     * @param {Backbone.Collection} fieldsCollection The form's fields collection.
     */
    forwardReplacedFieldValues: function( replacedFields, fieldsCollection ) {
        _.each( replacedFields, function( replaced ) {
            var ownGetValue = replaced.getValue;
            if ( 'function' != typeof ownGetValue ) return;

            replaced.getValue = function() {
                var current = fieldsCollection.get( replaced.get( 'id' ) );
                if ( current && current !== replaced ) {
                    return current.getValue.apply( current, arguments );
                }
                return ownGetValue.apply( replaced, arguments );
            };
        });
    }
});
